import type { UserFacility } from "@services/facilityManagement";
import type { User } from "@utils/userUtils";

/**
 * Map a facility object from POST /auth/login `user.facilities` into `UserFacility`
 * so the Hub can paint the sidebar before GET user-facilities returns enriched rows.
 */
export function mapLoginFacilityRowToUserFacility(
  row: Record<string, unknown>,
): UserFacility {
  const id = Number(row.id);
  const rawAssoc = row.association_id;
  let associationId: number | undefined;
  if (rawAssoc != null && rawAssoc !== "") {
    const n = Number(rawAssoc);
    associationId = Number.isFinite(n) ? n : undefined;
  }
  return {
    id: Number.isFinite(id) ? id : 0,
    facility_id: Number.isFinite(id) ? id : undefined,
    facility_name:
      typeof row.facility_name === "string" ? row.facility_name : undefined,
    organization_name:
      typeof row.organization_name === "string"
        ? row.organization_name
        : undefined,
    display_name:
      typeof row.display_name === "string" ? row.display_name : undefined,
    city: typeof row.city === "string" ? row.city : undefined,
    state: typeof row.state === "string" ? row.state : undefined,
    country_code:
      typeof row.country_code === "string" ? row.country_code : undefined,
    facility_type_id:
      row.facility_type_id != null ? Number(row.facility_type_id) : undefined,
    facility_type:
      typeof row.facility_type === "string" ? row.facility_type : undefined,
    facility_type_slug:
      typeof row.facility_type_slug === "string"
        ? row.facility_type_slug
        : undefined,
    user_role: typeof row.user_role === "string" ? row.user_role : undefined,
    access_level:
      typeof row.access_level === "string" ? row.access_level : undefined,
    is_primary: row.is_primary === true,
    association_id: associationId,
    address_1:
      typeof row.address_1 === "string" ? row.address_1 : undefined,
    address_2:
      typeof row.address_2 === "string" ? row.address_2 : undefined,
    postal_code:
      typeof row.postal_code === "string" ? row.postal_code : undefined,
    full_address:
      typeof row.full_address === "string" ? row.full_address : undefined,
    ccn_number: typeof row.ccn_number === "string" ? row.ccn_number : undefined,
    requires_medicare_certification:
      typeof row.requires_medicare_certification === "boolean"
        ? row.requires_medicare_certification
        : undefined,
  };
}

/** Facilities carried on the login /me user payload (if any). */
export function getFacilitiesFromLoginUser(user: User | null): UserFacility[] {
  const raw = user?.facilities;
  if (!Array.isArray(raw) || raw.length === 0) {
    return [];
  }
  const out: UserFacility[] = [];
  for (const item of raw) {
    if (item && typeof item === "object") {
      out.push(mapLoginFacilityRowToUserFacility(item as Record<string, unknown>));
    }
  }
  return out;
}
